import React, { useRef, useState } from 'react';
import { isMobile } from '../../utils/commonUtils';
import { getAppEnv } from '../../../config/env';
import './index.css';
const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

const CallUsModal = ({
  setShowModal,
  trackTemplateEvent,
  showWhatsAppForAssistedForm,
  customerCareNumber,
  assistantWidgetText,
  onWhatsAppIconClick,
  onCallUsIconClick,
  showCallUsForAssistedForm,
  showModal
}) => {
  return (
    <div
      className="modalViewOverlay"
      style={{ height: document.documentElement.scrollHeight }}
    >
      <div className="modalViewOuterContainer">
        <div className="modalViewContainer">
          {showModal && (
            <div className="modalWrapper assistedModal">
              <div
                className="assistedModal crossIc"
                onClick={() => {
                  setShowModal(false);
                  trackTemplateEvent?.('Cab_SEO_Assisted_Form_Closed');
                }}
              />
              <p className="modalTitle">We are here to assist you</p>
              {isMobile() &&
                (showWhatsAppForAssistedForm || showCallUsForAssistedForm) && (
                  <div className="form-btm-area">
                    <p className="callMsgTxt">{assistantWidgetText}</p>
                    <div className="bottomConnectWrapper">
                      {showCallUsForAssistedForm && customerCareNumber && (
                        <button
                          className="btm-prime-buttons outline-btn-call"
                          onClick={() => {
                            trackTemplateEvent?.(
                              'Cab_SEO_Assisted_Form_Call_Us_Clicked'
                            );
                            onCallUsIconClick?.();
                          }}
                        >
                          <img
                            src={`${PUBLIC_URL}/static/public/call.png`}
                            className="callOption"
                          />
                          Call Us
                        </button>
                      )}
                      {showWhatsAppForAssistedForm && (
                        <button
                          className="btm-prime-buttons solid-btn-whatsapp"
                          onClick={() => {
                            trackTemplateEvent?.(
                              'Cab_SEO_Assisted_Form_WhatsApp_Clicked'
                            );
                            onWhatsAppIconClick?.();
                          }}
                        >
                          <img
                            src={`${PUBLIC_URL}/static/public/whatsApp.png`}
                            className="whatsAppOption"
                          />
                          WhatsApp Chat
                        </button>
                      )}
                    </div>
                  </div>
                )}
            </div>
          )}
        </div>
        <div className="arrowDownIc" />
      </div>
      <div
        className="modalBackdrop"
        onClick={() => {
          setShowModal(false);
          trackTemplateEvent?.('Cab_SEO_Assisted_Call_Us_Form_Closed');
        }}
      ></div>
    </div>
  );
};

export default CallUsModal;
